import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, notification } from "antd";
import { Link } from "react-router-dom";
import { Row, Form, Input, Col, Select, Collapse, Dropdown, Menu } from "antd";

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import { MinusCircleTwoTone, PlusCircleTwoTone, SearchOutlined, MoreOutlined, EditOutlined, ClearOutlined, FireOutlined, FundViewOutlined } from "@ant-design/icons";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import ProductionApi from "../common/Apis/ProductionApi";
import AddTemp from "../common/Models/AfterCook/AddTemp";
import StockLevel from "../common/Models/AfterCook/StockLevel";
import AftreCookApi from "../common/Apis/AftreCookApi";
import Pagination from "../common/Pagination/Pagination"; 
import "../common/Pagination/Pagination.css"; 

const ListAfterCook = () => {
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [Production, setProduction] = React.useState([]);
  const getProduction = useCallback(() => {
    AftreCookApi.ListafterCook().then((response) => {
      setProduction(response.payloadDto?.sort((a, b) => b.id - a.id));
      setTotalElements(response.totalElements);
      
    })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getProduction();
    PageLoading();
  }, [getProduction, PageLoading]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRemovefilterProduction = (FiltergetProductionIndex) => {
    const newfilterProduction = [...filterRecipe];
    newfilterProduction.splice(FiltergetProductionIndex, 1);
    setFilterRecipe(newfilterProduction);
    if (FiltergetProductionIndex == 0) {
      getProduction();
    }
  };
  const handleClear = () => {
    getProduction();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterRecipe([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterRecipe, setFilterRecipe] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterRecipe = () => {
    setFilterRecipe([
      ...filterRecipe,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterRecipe
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=BETWEEN${createDateTimestamp(
            obj.answerType
          )}AND${createDateTimestamp(obj.name)}`;
        }
      })
      .join("&");

    let filderData = window.btoa(
      "componentCode=AFTER_COOK&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
    QuestionnairesApi.FilterQuestionsetNext(filderData)
      .then((response) => {
        setProduction(response.payloadDto?.sort((a, b) => b.id - a.id));
        setTotalElements(response.totalElements);
      })
      .catch((err) => { });
  };
  const createDateTimestamp = (Cdate) => {
    const date = new Date(Cdate);
    const unixTime = Math.floor(date.getTime());
    return unixTime;
  };
  const handleChangeTitle = (FiltergetproductionIndex, value) => {
    const newfilterProduction = [...filterRecipe];
    newfilterProduction[FiltergetproductionIndex].title = value;
    setFilterRecipe(newfilterProduction);
  };
  const handleChangeAnswertype = (FiltergetproductionIndex, value) => {
    const newfilterProduction = [...filterRecipe];
    newfilterProduction[FiltergetproductionIndex].answerType = value;
    setFilterRecipe(newfilterProduction);
  };

  const handleChangename = (FiltergetproductionIndex, value) => {
    const newfilterProduction = [...filterRecipe];
    newfilterProduction[FiltergetproductionIndex].name = value;
    setFilterRecipe(newfilterProduction);
  };

  const paginatedData = Production.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [modalEditData, setModalEditData] = useState("");
  const [AfterCookId, setAfterCookId] = useState("");

  const handleOpenEditModal = (ProductionID) => {
    ProductionApi.SingleProduction(ProductionID)
      .then((response) => {
        setModalEditData(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });
    setModalEditVisible(true);
  };
  const handlEditeCloseModal = () => {
    setModalEditVisible(false);
  };
  const [modalStockLevel, setModalStockLevel] = useState(false);

  const handleOpenStockLevel = (CookId) => {
    AftreCookApi.SingleafterCook(CookId)
      .then((response) => {
        setAfterCookId(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });
    setModalStockLevel(true);
  };
  const handlStockLevelCloseModal = () => {
    setModalStockLevel(false);
  };
  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">
          <td style={{ width: "8%" }} className="pt-3 ">
            {convertTo12HourFormat(item?.timeOfCookingFinished)}
          </td>
          <td style={{ width: "17%" }} className="pt-3">
            {item?.batchCodeOfTheCookedProduct}
          </td>
          <td style={{ width: "5%" }} className="pt-3">
            {item?.temperatureOfTheProductAfterCook}
          </td>
          <td style={{ width: "10%" }} className="pt-3">
            {formatDate(item?.oubd)}
          </td>
          <td style={{ width: "10%" }} className="pt-3">
            {formatDate(item?.newSellByDateOfTheCookedProduct)}
          </td>
          <td style={{ width: "5%" }} className="pt-3 text-center">
            {item?.quantityOfTheCookedProduct}
          </td>

          <td style={{ width: "8%" }}>

            <div className="d-flex justify-content-center">
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      key="Take"
                      onClick={() => handleOpenEditModal(item.id)}
                    >
                      <EditOutlined /> Take Temp
                    </Menu.Item>

                    <Menu.Item
                      key="Stock"
                      onClick={() => handleOpenStockLevel(item.id)}>
                      <FundViewOutlined /> Stock Level
                    </Menu.Item>

                    <Menu.Item
                      key="Cooling">
                      <SearchOutlined /> Cooling Process
                    </Menu.Item>
                    <Menu.Item
                      key="Waste">
                      <ClearOutlined /> Waste
                    </Menu.Item>
                    <Menu.Item
                      key="HotHold">
                      <FireOutlined /> Hot Hold
                    </Menu.Item>

                  </Menu>
                }
                trigger={["click"]}
                placement="bottom"
              >
                <div className="action-circle">
                  <MoreOutlined />
                </div>
              </Dropdown>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={7} className="text-center ">
            <img
              src="/assest/Images/emptyIcon.svg"
              className="logo-png mt-3"
              style={{ width: "10%" }}
            />
            <br />
            <Link
              className="btn btn-primary btn-save m-0 my-2 "
              to={'/production'}
            >
              Add Production
            </Link>
          </td>
        </tr>
      );
    }
  };
  function convertTo12HourFormat(timeString) {
    const [hours, minutes] = timeString?.split(':').map(Number);
    const amOrPm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    return `${formattedHours}:${formattedMinutes} ${amOrPm}`;
  }
  function formatDate(date) {
    const dateNew = parseInt(date, 10);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(dateNew).toLocaleDateString(
      "en-US",
      options
    );

    const [month, day, year] = formattedDate.split(" ");
    const capitalizedMonth = month.toUpperCase();
    return `${day} ${capitalizedMonth} ${year}`;
  }
  const handleDeleteProduction = (ProductionID) => {
    ProductionApi.DeleteProduction(ProductionID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getProduction();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterRecipe.map((input, filterProductionIndex) => (
                    <div key={filterProductionIndex}>
                      <Row gutter={12} className="pt-2">
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterProductionIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterProductionIndex, value)
                              }
                              options={[
                                {
                                  value: "newSellByDateOfTheCookedProduct",
                                  label: "Sell By Date",
                                },
                                {
                                  value: "batchCodeOfTheCookedProduct",
                                  label: "Batch Code",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={4}>
                          {filterRecipe[filterProductionIndex].title ==
                            "newSellByDateOfTheCookedProduct" ? (
                            <>
                              <Form.Item
                                name={`nameto${filterProductionIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  placeholder="Filter By"
                                  onChange={(e) =>
                                    handleChangeAnswertype(
                                      filterProductionIndex,
                                      e.target.value
                                    )
                                  }
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`type${filterProductionIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterProductionIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>


                        <Col span={5}>
                          {filterRecipe[filterProductionIndex].title ==
                            "newSellByDateOfTheCookedProduct" ? (
                            <>
                              <Form.Item
                                name={`name${filterProductionIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select End Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterProductionIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`name${filterProductionIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterProductionIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>


                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterProductionIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterRecipe}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterProduction(
                                      filterProductionIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            {/* {paginatedData?.length > 0 && (
              <Link
                className="btn btn-primary btn-save m-0 my-2 "
                to={'/production'}
              >
                Add Production
              </Link>
            )} */}
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Batch Code</th>
                  <th>Temp</th>
                  <th>OUBD</th>
                  <th>Sell By Date</th>
                  <th>Quantity</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>

           {paginatedData.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(Production.length / PaginateLimit)}
            onPageChange={handlePageChange}
            maxVisiblePages={5}
            showPageInfo={true}
            totalItems={totalElements}
            pageSize={PaginateLimit}
          />
        )}


          </div>
        </Content>
        <AddTemp
          visible={modalEditVisible}
          onClose={handlEditeCloseModal}
          ProductDetails={modalEditData}
        />
        <StockLevel
          visible={modalStockLevel}
          onClose={handlStockLevelCloseModal}
          afterCookId={AfterCookId}
        />
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default ListAfterCook;
